import qr from 'qrcode-generator'

/* Der QR-Kode für die Authenticator-App.
 *
 * Warum ein Paket und nicht selbst gerechnet: Ein QR-Kode ist
 * Reed-Solomon über GF(256), Maskenwahl und Formatbits — rund
 * zweihundertfünfzig Zeilen, die man nur gegen eine fremde, richtige
 * Ausgabe prüfen kann. Eine selbst gebaute Rechnung gegen selbst
 * erzeugte Werte zu halten prüft nichts. Also hier das Gegenteil der
 * Entscheidung bei TOTP: Dort war die RFC die Prüfung und das Rechnen
 * fünfzehn Zeilen, hier ist die Rechnung lang und die Prüfung fremd.
 *
 * `qrcode-generator` hat keine eigenen Abhängigkeiten — es bleibt bei
 * einem Paket, nicht bei einem Baum.
 *
 * Gezeichnet wird als SVG aus einem Pfad, nicht als Bild: Ein SVG ist
 * bei jeder Größe scharf, und ein Telefon, das schräg draufhält,
 * braucht jede Schärfe.
 */

export function QrKode({ inhalt, groesse = 200 }:
                       { inhalt: string; groesse?: number }) {
  // Fehlerkorrektur M und Typ 0 heißt: die Bibliothek sucht die
  // kleinste Fassung, die den Text fasst. Eine feste Fassung wäre
  // entweder zu klein für lange Adressen oder unnötig fein.
  const k = qr(0, 'M')
  k.addData(inhalt)
  k.make()

  const n = k.getModuleCount()
  // Vier Module Rand sind Vorschrift, nicht Geschmack: Ohne den
  // „ruhigen Bereich" findet keine Kamera die Ecken.
  const rand = 4
  const seite = n + rand * 2

  const stuecke: string[] = []
  for (let z = 0; z < n; z++) {
    for (let s = 0; s < n; s++) {
      if (k.isDark(z, s)) stuecke.push(`M${s + rand},${z + rand}h1v1h-1z`)
    }
  }

  return (
    <svg className="qr" width={groesse} height={groesse}
         viewBox={`0 0 ${seite} ${seite}`}
         role="img" aria-label="QR-Kode zum Einrichten der App">
      <rect width={seite} height={seite} fill="#fff" />
      <path d={stuecke.join('')} fill="#000" shapeRendering="crispEdges" />
    </svg>
  )
}

/* Der Schlüssel zum Abtippen — für alle ohne Kamera.
 *
 * In Blöcken zu vier Zeichen. Zweiunddreißig Zeichen am Stück tippt
 * niemand fehlerfrei ab; in Vierergruppen sieht man sofort, wo man
 * stehengeblieben ist.
 */
export function Schluessel({ adresse }: { adresse: string }) {
  const geheim = new URL(adresse).searchParams.get('secret') ?? ''
  const blocks = geheim.match(/.{1,4}/g)?.join(' ') ?? geheim
  return (
    <div className="schluessel">
      <span className="dezent">Ohne Kamera — Schlüssel von Hand eintippen:</span>
      <code>{blocks}</code>
    </div>
  )
}
